import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/layouts/MainLayout'
import HomePage from '@/pages/HomePage'
import IncomePage from '@/pages/IncomePage'
import ExpensePage from '@/pages/ExpensePage'
import LoginPage from '@/pages/LoginPage'
import CallbackPage from '@/pages/CallbackPage'
import ErrorPage from '@/pages/ErrorPage'
import AuthService from '@/services/AuthService'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '/',
          name: 'IndexPage',
          component: HomePage
        },
        {
          path: '/home',
          name: 'HomePage',
          component: HomePage
        },
        {
          path: '/income',
          name: 'IncomePage',
          component: IncomePage
        },
        {
          path: '/expense',
          name: 'ExpensePage',
          component: ExpensePage
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/callback',
      name: 'CallbackPage',
      component: CallbackPage
    },
    {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !AuthService.isAuthenticated()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js